import {Navigate, Outlet, useLocation} from "react-router-dom"
import {useEffect} from "react"
import {redirectToKeycloak} from "../services/auth"
import Loading from "../components/loading"

export function RequireAuth({ account }) {
  const location = useLocation()

  useEffect(() => {
    if (!account) {
      sessionStorage.setItem('callbackUrlReturn', window.location.href)
      redirectToKeycloak()
    }
  }, [account, location])

  if (!account) return <Loading fullPage />

  return <Outlet />
}

export function RequireGuest({ account }) {
  if (account) return <Navigate to="/planejadora" replace />
  return <Outlet />
}